export enum ErrorCodeEnum {
  TOKEN_EXPIRED = 'E001',
  DUPLICATE_KEY = 'E002',
  QR_CODES_NOT_AVAILABLE = 'E010',
}
